export const serverRoutes = {
  availableCohorts: {
    all(partnerId: string) {
      return `/v1/public-inventory/${partnerId}` as const;
    },
    allForApp(partnerId: string) {
      return `/v1/public-inventory/${partnerId}/app` as const;
    },
    searchByCatalogueIds(partnerId: string, catalogueIds: string) {
      return `/v1/public-inventory/${partnerId}/search?catalogueIds=${catalogueIds}` as const;
    },
  },

  checkout: {
    complete(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/complete` as const;
    },
    couponsAdd(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/coupons` as const;
    },
    couponsRemove(partnerId: string, code: string) {
      return `/v2/commerce/checkout/${partnerId}/coupons/${code}` as const;
    },
    getCart(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}` as const;
    },
    guardian(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/guardian` as const;
    },
    lineItemAdd(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/items` as const;
    },
    lineItemRemove(partnerId: string, id: string) {
      return `/v2/commerce/checkout/${partnerId}/items/${id}` as const;
    },
    student(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/student` as const;
    },
    validate(partnerId: string) {
      return `/v2/commerce/checkout/${partnerId}/validate` as const;
    },
  },

  orders: {
    getById(orderId: string) {
      return `/v2/commerce/orders/${orderId}` as const;
    },
  },

  enrollments(partnerId: string) {
    return `/enrollments/partner/${partnerId}` as const;
  },
};
